import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

// eslint-disable-next-line import/prefer-default-export
export async function getThirdPartyAuthContext(urlParams) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: urlParams,
    isPublic: true,
  };

  try {
    const { data } = await getAuthenticatedHttpClient()
      .get(
        `${getConfig().LMS_BASE_URL}/api/mfe_context`,
        requestConfig,
      );
    return {
      fieldDescriptions: data.registrationFields || {},
      optionalFields: data.optionalFields || {},
      thirdPartyAuthContext: data.contextData || {},
    };
  } catch (e) {
    // Return empty defaults if the endpoint doesn't exist (404)
    if (e.response && e.response.status === 404) {
      return {
        fieldDescriptions: {},
        optionalFields: {},
        thirdPartyAuthContext: {
          providers: [],
          secondaryProviders: [],
          finishAuthUrl: null,
          errorMessage: null,
          currentProvider: null,
          platformName: null,
          pipelineUserDetails: {},
        },
      };
    }
    throw e;
  }
}
